import { useTranslation } from 'react-i18next';

import { CheckboxField as CheckboxElement } from 'Common/Form';

import { CheckboxSection } from '../styled';

type Props = {
  isEdit: boolean;
};

export const CheckboxOptionsSection = ({ isEdit }: Readonly<Props>) => {
  const { t } = useTranslation();

  return (
    <CheckboxSection>
      <CheckboxElement name="wantToBeCoordinator" label={t('courseForm.wantToBeCoordinator')} />
      <CheckboxElement
        name="wantToBeTrainer"
        label={t('courseForm.wantToBeTrainer')}
        disabled={isEdit}
      />
      <CheckboxElement name="isDemo" label={t('courseForm.isDemo')} disabled={isEdit} />
    </CheckboxSection>
  );
};
